<template>
  <div @mouseenter="mouseOver" @mouseleave="mouseLeave" >
    <!-- <svg ref="svgWrapper" >
      <defs>
        <filter :id="`displacementMap_${id}`">
          <feTurbulence ref="turbulence" type="turbulence" baseFrequency="0.0"
            numOctaves="2" result="turbulence" seed="53"/>
          <feDisplacementMap in2="turbulence" in="SourceGraphic"
          scale="30" xChannelSelector="R" yChannelSelector="B"/>
        </filter>
      </defs>
      :style="`filter: url(#displacementMap_${id})`"
    </svg> -->
    <h1 class="svgfilter">
      <slot></slot>
      <div class="worktype">
        {{worktype}}
      </div>
    </h1>
  </div>
</template>
<script>
import { TimelineMax, TweenMax, Power3 } from 'gsap';
import { map, toDegrees } from '@/scripts/utils/math'
import isMobile from 'ismobilejs';

export default {
  name: 'MainTitle',
  data() {
    return {
    };
  },
  props: {
    id: {
      type: Number,
    },
    worktype: {
      type: String,
      defaut: 'website'
    },
  },
  created() {
  },
  mounted() {
  },
  methods: {
    mouseOver() {
      const mouseball = document.getElementById('mouseball')
      TweenMax.to(mouseball, 0.5, {
        width: '50px',
        height: '50px',
        ease: Power3.easeout
      })
      // this.hoverSound.start();
      // const { turbulence } = this.$refs
      // TweenMax.to(turbulence, 1, {
      //   attr: { baseFrequency: 0 }
      // })
    },
    mouseLeave() {
      const mouseball = document.getElementById('mouseball')

      TweenMax.to(mouseball, 0.5, {
        width: '30px',
        height: '30px',
        ease: Power3.easeout
      })
      // const { svgWrapper, turbulence } = this.$refs;
      // TweenMax.to(turbulence, 1, {
      //   attr: { baseFrequency: 0.070 }
      // })
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="../styles/components/MainTitle.styl" scoped lang="stylus"></style>
